import { render, staticRenderFns } from "./speaking.vue?vue&type=template&id=7910ea21"
import script from "./speaking.vue?vue&type=script&lang=js"
export * from "./speaking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports